/**
 * 啟動狀態
 * 遊戲初始化的第一個狀態，設置基本配置和載入進度條
 */
export default class Boot {

  /**
   * 預載入階段
   * 載入進度條圖片並設置螢幕縮放模式
   */
  preload() {
    // 使用 SHOW_ALL 模式：保持比例，適應容器，不會變形
    // 這適合在 iframe 中使用，確保遊戲內容不會超出容器
    this.scale.scaleMode = Phaser.ScaleManager.SHOW_ALL;
    // 移除強制橫屏，讓遊戲適應容器尺寸
    this.scale.forceLandscape = false;
    // 設置縮放時保持比例
    this.scale.pageAlignHorizontally = true;
    this.scale.pageAlignVertically = true;

    // 確保 URL 是字串格式
    const preloaderUrl = require('../assets/images/loading_bar.png');
    const ensureString = (url) => {
      if (typeof url === 'string') {
        return url;
      }
      if (url && typeof url === 'object') {
        return url.default || url.toString();
      }
      return String(url || '');
    };
    this.load.image('preloader', ensureString(preloaderUrl));
  }

  /**
   * 創建階段
   * 設置輸入配置並轉換到預載入狀態
   */
  create() {
    this.game.input.mouse.capture = true;
    this.game.input.maxPointers = 1;
    this.game.state.start('preload');
  }
}